import type { IWidget } from "../widget-types/types";
import type { IDataFetcher, IDataFetcherFactory } from "./IDataFetcher";
import widgetResource from "app/common/resources/widgetResource";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { IFetchService } from "app/services/fetchService";
import { DefaultFetchService } from "app/services/fetchService";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

class MmxTrafficShareDashboardDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const params = { ...widget.apiParams };
        const metric = params.webSource === devicesTypes.DESKTOP ? widget.apiParams.metric : "TrafficSourcesOverview";
        let componentId = "WebsiteOverviewDesktop";
        if (params.webSource === devicesTypes.MOBILE) {
            componentId = "MarketingMixMobile";
        } else if (params.webSource === devicesTypes.TOTAL) {
            componentId = "MarketingMixTotal";
        }
        return {
            fetch: () => {
                if (params.webSource === devicesTypes.DESKTOP) {
                    const resource = widgetResource.resourceByController(
                        componentId,
                        metric,
                        fetchWithFullResponseConfig,
                    ).Graph;
                    return resource(widget.apiParams).then(...fetchWithFullResponseInterceptorHandlers);
                }
                const apiParams = { ...widget.apiParams };
                apiParams.timeGranularity = apiParams.timeGranularity || GranularityNames.MONTHLY;
                const keys = apiParams.keys.split(",");
                const isCompare = keys.length > 1;
                const fetchService: IFetchService = DefaultFetchService.getInstance();
                return fetchService
                    .get(`widgetApi/${componentId}/${metric}/BarChart`, apiParams)
                    .then(...fetchWithFullResponseInterceptorHandlers)
                    .then((response) => {
                        const result: any = { Data: {} };
                        if (isCompare) {
                            Object.keys(response?.Data?.TrafficShare).forEach((channel) => {
                                const Breakdown = response?.Data?.TrafficShare[channel]?.BreakDown;
                                Object.keys(Breakdown).forEach((date) => {
                                    Object.keys(Breakdown[date]).forEach((site) => {
                                        if (!result.Data[site]) {
                                            result.Data[site] = {};
                                        }
                                        if (!result.Data[site][channel]) {
                                            result.Data[site][channel] = [];
                                            result.Data[site][channel][0] = [];
                                        }
                                        result.Data[site][channel][0].push({
                                            Key: date,
                                            Value: Breakdown[date][site],
                                        });
                                    });
                                });
                            });
                        } else {
                            const Breakdown = response?.Data?.TrafficShare?.Data?.BreakDown;
                            const site = keys[0];
                            Object.keys(Breakdown).forEach((date) => {
                                Object.keys(Breakdown[date]).forEach((channel) => {
                                    if (!result.Data[site]) {
                                        result.Data[site] = {};
                                    }
                                    if (!result.Data[site][channel]) {
                                        result.Data[site][channel] = [];
                                        result.Data[site][channel][0] = []; //to have same structure as desktop
                                    }
                                    result.Data[site][channel][0].push({
                                        Key: date,
                                        Value: Breakdown[date][channel],
                                    });
                                });
                            });
                        }
                        return result;
                    });
            },
            destroy: () => undefined,
        };
    }
}

export default new MmxTrafficShareDashboardDataFetcherFactory();
